import styled from 'styled-components';

export const ContentArea = styled.div`
  padding: 0;
  flex-grow: 1;
  height: auto;
  overflow-y: auto;
  overflow-x: auto;
  margin-left: 59px;
  padding-bottom: 20px;
  @media only screen and (max-width: 768px) {
    margin-left: 42px;
  }
  @media only screen and (max-width: 600px) {
    margin-left: 0px;
  }
`;

export const LayoutContainer = styled.div`
  flex-grow: 1;
  z-index: 1;
  overflow: hidden;
  position: relative;
  display: flex;
  height: 100vh;
`;

export const Toolbar = styled.div`
  min-height: 82px;
  margin-bottom: 20px;
  @media only screen and (max-width: 600px) {
    min-height: 114px;
  }
`;

export const Noresults = styled.div `
display: flex;
justify-content: center;
margin: auto;
`

